<span>{{ value | date: 'shortDate' : '' : locale }}</span>
